import { useEffect, useRef, useState } from "react";
import { Badge, Collapse } from "react-bootstrap";

const Section = ({
  name,
  Icon,
  ActiveIcon,
  children,
  activeSection,
  activeColor,
  isActiveSection,
  isVisible = true,
  badge = null,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const childRef = useRef(null);

  const invertTextWhenActive = true;

  useEffect(() => {
    if (childRef.current) {
      // Check if any of the children are active and set open section
      const hasActiveChildren = childRef.current.querySelector("li.active");
      setIsOpen(!!hasActiveChildren);
    }
  }, [childRef]);

  if (!isVisible) {
    return null;
  }

  return (
    <li
      className={`user ${name.toLowerCase() === activeSection ? "active-section" : ""}`}
      style={{
        marginBottom: "2rem",
        marginTop: 0,
        paddingBottom: activeSection ? "1rem" : 0,
        borderBottom: "none",
        width: "100%",
        textDecoration: "none",
        borderRadius: "10px",
      }}
    >
      <a
        href="#"
        className="active"
        onClick={(e) => {
          e.preventDefault();
          setIsOpen(!isOpen);
        }}
        style={{
          background: isActiveSection ? activeColor : "inherit",
        }}
      >
        {invertTextWhenActive && ActiveIcon && isActiveSection ?
          <ActiveIcon />
        : Icon && <Icon />}
        <p
          style={{
            color: isActiveSection && invertTextWhenActive ? "#FFF" : "#2e0054",
            // color: "#2e0054",
          }}
        >
          {name}
          {badge && (
            <Badge
              className={`badge-${isActiveSection ? "secondary" : "primary"}`}
              style={{ marginLeft: "0.5rem", fontSize: "9px" }}
              pill
            >
              {badge}
            </Badge>
          )}
          <span className={`caret ${isOpen && `rotate-180`} dropdown-toggle`}></span>
        </p>
      </a>

      <Collapse in={isOpen}>
        <ul className="nav" ref={childRef}>
          {children}
        </ul>
      </Collapse>
    </li>
  );
};

export default Section;
